import React from "react"
import { FormGroup } from "reactstrap"
import { Trans } from "@lingui/react"
import PropTypes from "prop-types"

export const FormButton = (props) => (
  <FormGroup>
    <button
      style={props.style}
      type={props.type}
      className={props.className}
      onClick={props.handleClick}
      disabled={props.disabled}
    >
      <Trans id={props.value}>{props.value}</Trans>
    </button>
  </FormGroup>
)

FormButton.propTypes = {
  style: PropTypes.object,
  type: PropTypes.string,
  className: PropTypes.string,
  handleClick: PropTypes.func,
  disabled: PropTypes.bool,
  value: PropTypes.string,
}
